export enum FileTypes {
  IMAGE = "image",
  SHEET = "sheet",
  PDF = "pdf",
  TEXT = "text",
  UNKNOWN = "unknown",
}
